import { authOptions } from '@/app/api/auth/[...nextauth]/route';
import { deleteCookie } from 'cookies-next';
import { getServerSession } from 'next-auth';
import { signOut } from 'next-auth/react';
import { redirect } from 'next/navigation';

// session and handshake in server side
// const session = await getServerSessionData();
// const handshake = (await cookies()).get('handshake')?.value;

// session and handshake in client side
// const { data: session, status } = useSession();
// const handshake = getCookie('handshake');

export const getServerSessionData = async ({
  allowRedirection = true,
  redirectionLink = '/',
} = {}) => {
  const session = await getServerSession(authOptions);

  if (!session && allowRedirection) {
    redirect(redirectionLink);
  }

  return session;
};

export const signOutHandler = () => {
  localStorage.removeItem('cart');
  localStorage.removeItem('checkout');
  deleteCookie('quote');
  deleteCookie('mage');

  signOut({ callbackUrl: '/' });
};
